import { theme as baseTheme } from './theme';

// Colores que el administrador puede personalizar para sus vistas públicas
// (/tienda, /cita, /ticket, /news). El resto del tema se mantiene por defecto.
export const PUBLIC_THEME_KEYS = ['background', 'surface', 'text', 'primary'];

const HEX = /^#([0-9a-f]{3}|[0-9a-f]{6})$/i;

// Fusiona los colores personalizados de la empresa sobre el tema por defecto.
// Solo se aceptan colores hexadecimales válidos; cualquier otro valor se ignora.
export function mergePublicTheme(custom) {
  const overrides = {};
  if (custom && typeof custom === 'object') {
    for (const k of PUBLIC_THEME_KEYS) {
      const v = custom[k];
      if (typeof v === 'string' && HEX.test(v.trim())) overrides[k] = v.trim();
    }
  }
  return { ...baseTheme, colors: { ...baseTheme.colors, ...overrides } };
}

// Variables CSS para que los estilos definidos a nivel de módulo (botones,
// inputs, paneles) también reflejen los colores personalizados. Se aplican en
// el contenedor raíz de cada vista pública.
export function publicThemeVars(colors) {
  return {
    '--pub-bg': colors.background,
    '--pub-surface': colors.surface,
    '--pub-text': colors.text,
    '--pub-muted': colors.textMuted,
    '--pub-border': colors.border,
    '--pub-accent': colors.primary,
  };
}
